var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-bullets"},_vm._l((_vm.lines),function(line,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(_vm.$tdb(line))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }